var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 23.75V8.908C0 4.318 3.735.583 8.325.583h13.681a8.34 8.34 0 0 1 8.327 8.325v2.56c0 4.59-3.735 8.325-8.325 8.325H8.518zM8.325 2.439a6.48 6.48 0 0 0-6.469 6.469v11.933l6.253-2.905h13.899a6.48 6.48 0 0 0 6.469-6.469v-2.56a6.48 6.48 0 0 0-6.471-6.469H8.325zm.612 6.328a1.765 1.765 0 1 1 0 3.53 1.765 1.765 0 0 1 0-3.53m12.458 0a1.765 1.765 0 1 1 0 3.53 1.765 1.765 0 0 1 0-3.53m-6.23 0a1.765 1.765 0 1 1 0 3.53 1.765 1.765 0 0 1 0-3.53"
  })));
};
export default SvgNotification;